<template>
  <div style="padding: 20px;">
    <Row>
      <Form inline :label-width="110">
        <FormItem label="用户UID">
          <Input v-model="searchForm.uid" placeholder="输入用户UID查询" clearable style="width:200px"></Input>
        </FormItem>
        <FormItem label="所属系统对接">
          <Select v-model="searchForm.system" placeholder="选择所属系统对接" style="width:200px">
            <Option v-for="item in systemOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="上游渠道">
          <Select v-model="searchForm.cid" placeholder="选择上游渠道" style="width:200px">
            <Option v-for="item in cidList" :value="item.value" :key="item.value">
              {{ item.label }} (ID: {{ item.value }})
            </Option>
          </Select>
        </FormItem>
        <FormItem label="操作">
          <Button type="primary" @click="getList">查询</Button>
          <Button type="" @click="resetSearchForm" style="margin: 0 1rem">重置</Button>
          <Button type="success" @click="handleAdd">添加映射</Button>
        </FormItem>
      </Form>
    </Row>

    <Table border :columns="columns" :data="datas" style="margin-top: 15px;">
      <template slot-scope="{ row }" slot="system_name">
        <span>{{ getName(systemOptions, row.system_type, 'value', 'label') }}</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" @click="handleEdit(row)" style="margin-right: 5px">编辑</Button>
        <Button type="error" size="small" @click="handleDelete(row)">删除</Button>
      </template>
    </Table>

    <Modal v-model="modalShow" :title="formItem.id ? '编辑映射' : '新增映射'" @on-ok="save">
      <Form :model="formItem" :label-width="100">
        <FormItem label="下游客户">
          <Select v-model="formItem.uid" filterable placeholder="下游客户">
            <Option v-for="item in uidList" :value="item.value" :key="item.value">
              {{ item.label }} (ID: {{ item.value }})
            </Option>
          </Select>
        </FormItem>
        <FormItem label="上游渠道">
          <Select v-model="formItem.cid" filterable placeholder="选择上游渠道">
            <Option v-for="item in cidList" :value="item.value" :key="item.value">
              {{ item.label }} (ID: {{ item.value }})
            </Option>
          </Select>
        </FormItem>
        <FormItem label="业务媒体id">
          <Input v-model="formItem.medium_code_id" placeholder="选择业务媒体id"></Input>
        </FormItem>
        <FormItem label="所属系统对接">
          <Select v-model="formItem.system_type" placeholder="选择所属系统对接">
            <Option v-for="item in systemOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import {getInterList, saveInter, delInter} from "@/api/mediumMapping";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      searchForm: {
        uid: '',
        cid: '',
        system: '',
      },
      datas: [],
      uidList: [],   // 客户下拉
      cidList: [],   // 客户下拉
      mediumOptions: [], // 介质常量
      systemOptions: [], // 系统常量
      modalShow: false,
      formItem: {id: '', uid: '', cid: '', medium_code_id: '', system_type: ''},
      columns: [
        {title: 'ID', key: 'id', width: 70, align: 'center'},
        {title: '用户UID', key: 'uid_name', align: 'center'},
        {title: '上游渠道', key: 'cid_name', align: 'center'},
        {title: '业务媒体id', key: 'medium_code_id', align: 'center'},
        {title: '所属系统对接', slot: 'system_name', align: 'center'},
        {title: '更新时间', key: 'update_time', align: 'center'},
        {title: '操作', slot: 'action', width: 150, align: 'center'}
      ]
    };
  },
  computed: {...mapGetters(['token'])},
  mounted() {
    this.getList();
  },
  methods: {
    // 通用辅助：ID转名称
    getName(list, val, key, label) {
      const item = list.find(i => i[key] == val);
      return item ? item[label] : val;
    },
    async getList() {
      let res = await getInterList(this, {
        token: this.token,
        ...this.searchForm
      });
      console.log('res', res)
      if (res) {
        this.datas = res.data.interList;
        this.uidList = res.data.uidList;
        this.cidList = res.data.cidList;
        // 关键：从后端同步常量
        this.mediumOptions = res.data.constants.medium_codes;
        this.systemOptions = res.data.constants.system_types;
      }
    },
    resetSearchForm() {
      this.searchForm = {
        uid: '',
        cid: '',
        system: '',
      }
      this.getList()
    },
    handleAdd() {
      this.formItem = {id: '', uid: '', cid: '', medium_code_id: '', system_type: ''};
      this.modalShow = true;
    },
    handleEdit(row) {
      this.formItem = JSON.parse(JSON.stringify(row));
      this.modalShow = true;
    },
    async save() {
      let res = await saveInter(this, {
        token: this.token,
        data: this.formItem
      });
      if (res.code == 1) {
        this.$Message.success('操作成功');
        this.getList();
      } else {
        this.$Message.error(res.msg);
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定删除UID为 ${row.uid} 的映射吗？`,
        onOk: async () => {
          let res = await delInter(this, {token: this.token, id: row.id});
          if (res.code == 1) {
            this.$Message.success('已删除');
            this.getList();
          }
        }
      });
    }
  }
};
</script>